import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('settings')
export class SettingsEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column({
    type:"text",
    nullable: true,
    name:"fb_authkey"
  })
  fbAuthKey:string;
  @Column({
    type:"text",
    nullable: true,
    name:"twitter_authkey"
  })
  twitterAuthKey:string;
  @Column({
    type:"text",
    nullable: true,
    name:"insta_authkey"
  })
  instaAuthKey:string;
  @Column({
    type:"varchar",
    nullable: true,
    length:1000,
    name:"terms_conditions_url"
  })
  termsConditionsUrl :string;
  @Column({
    type:"varchar",
    nullable: true,
    length:1000,
    name:"about_us_url"
  })
  aboutUsUrl :string;  
  @Column({
    type:"varchar",
    nullable: true,
    length:1000,
    name:"icon_url"
  })
  iconUrl :string;
  @Column({
    type:"varchar",
    nullable: true,
    length:1000,
    name:"icon_upload_url"
  })
  iconUploadUrl  :string;
  @Column({
    type:"varchar",
    nullable: true,
    length:1000,
    name:"home_image_url"
  })
  homeImageUrl:string;
  @Column({
    type:"varchar",
    nullable: true,
    length:1000,
    name:"upload_url"
  })
  uploadUrl:string;
}